import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=7e5385f4&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&id=7e5385f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5385f4",
  null
  
)

export default component.exports